/* eslint-disable no-unused-vars */
import { Buttons } from 'components';
import { Plus, Pen, UserCircle } from 'assets/icons';

const icon = <UserCircle />;

const fontStyles = {
  fontSize: '14px',
  fontWeight: '500',
  color: '#94A3B8',
};

const columnStyle = {
  display: 'grid',
  gridTemplateColumns: '1fr',
  gap: '24px',
  marginBottom: '32px',
  ...fontStyles,
};

const columnStyle4 = {
  ...columnStyle,
  gridTemplateRows: 'repeat(4, 60px)',
};

const columnStyle6 = {
  ...columnStyle,
  gridTemplateRows: 'repeat(6, 60px)',
};

const rowStyle = {
  display: 'grid',
  gridTemplateColumns: '80px 200px 300px 200px 300px',
  gap: '24px',
  ...fontStyles,
};

const ButtonsPage = () => {
  return (
    <div style={{ padding: '32px', background: 'white', margin: '32px 0' }}>
      <h1 style={{ marginBottom: '32px' }}>Buttons</h1>

      {/************ FIRST ROW ************/}
      <div style={{ ...rowStyle, marginBottom: '32px' }}>
        <div></div>
        <div>primary normal</div>
        <div>primary small</div>
        <div>secondary normal</div>
        <div>secondary small</div>
      </div>
      <div style={rowStyle}>
        <div style={columnStyle4}>
          <div>
            default
            <br />
            (no icon)
          </div>
          <div>default</div>
          <div>pressed</div>
          <div>disabled</div>
        </div>

        {/****** PRIMARY MORNAL ******/}
        <div style={columnStyle4}>
          <Buttons.PrimaryNormal onClick={() => {}}>Label</Buttons.PrimaryNormal>
          <Buttons.PrimaryNormal icon={icon} onClick={() => {}}>
            Label
          </Buttons.PrimaryNormal>
          <div>-</div>
          <Buttons.PrimaryNormal icon={icon} isDisabled={true} onClick={() => {}}>
            Label
          </Buttons.PrimaryNormal>
        </div>

        {/****** PRIMARY SMALL ******/}
        <div style={columnStyle4}>
          <Buttons.PrimarySmall onClick={() => {}}>Label</Buttons.PrimarySmall>
          <Buttons.PrimarySmall icon={icon} onClick={() => {}}>
            Label
          </Buttons.PrimarySmall>
          <div>-</div>
          <Buttons.PrimarySmall icon={icon} isDisabled={true} onClick={() => {}}>
            Label
          </Buttons.PrimarySmall>
        </div>

        {/****** SECONDARY NORMAL ******/}
        <div style={columnStyle4}>
          <Buttons.SecondaryNormal onClick={() => {}}>Label</Buttons.SecondaryNormal>
          <Buttons.SecondaryNormal icon={icon} onClick={() => {}}>
            Label
          </Buttons.SecondaryNormal>
          <Buttons.SecondaryNormal icon={icon} isPressed={true} onClick={() => {}}>
            Label
          </Buttons.SecondaryNormal>
          <Buttons.SecondaryNormal icon={icon} isDisabled={true} onClick={() => {}}>
            Label
          </Buttons.SecondaryNormal>
        </div>

        {/****** SECONDARY SMALL ******/}
        <div style={columnStyle4}>
          <Buttons.SecondarySmall onClick={() => {}}>Label</Buttons.SecondarySmall>
          <Buttons.SecondarySmall icon={icon} onClick={() => {}}>
            Label
          </Buttons.SecondarySmall>
          <Buttons.SecondarySmall icon={icon} isPressed={true} onClick={() => {}}>
            Label
          </Buttons.SecondarySmall>
          <Buttons.SecondarySmall icon={icon} isDisabled={true} onClick={() => {}}>
            Label
          </Buttons.SecondarySmall>
        </div>
      </div>

      {/************ SECOND ROW ************/}
      <div style={{ ...rowStyle, margin: '32px 0' }}>
        <div></div>
        <div>destructive normal</div>
        <div>destructive small</div>
        <div>tertiary normal</div>
        <div>tertiary small</div>
      </div>
      <div style={rowStyle}>
        <div style={columnStyle6}>
          <div>
            default
            <br />
            (no icon)
          </div>
          <div>default</div>
          <div>pressed</div>
          <div>disabled</div>
          <div>muted</div>
          <div>destructive</div>
        </div>

        {/****** DESTTRUCTIVE NORMAL ******/}
        <div style={columnStyle4}>
          <Buttons.DestructiveNormal onClick={() => {}}>Label</Buttons.DestructiveNormal>
          <Buttons.DestructiveNormal icon={icon} onClick={() => {}}>
            Label
          </Buttons.DestructiveNormal>
          <div>-</div>
          <Buttons.DestructiveNormal icon={icon} isDisabled={true} onClick={() => {}}>
            Label
          </Buttons.DestructiveNormal>
          <div>-</div>
          <div>-</div>
        </div>

        {/****** DESTTRUCTIVE SMALL ******/}
        <div style={columnStyle4}>
          <Buttons.DestructiveSmall onClick={() => {}}>Label</Buttons.DestructiveSmall>
          <Buttons.DestructiveSmall icon={icon} onClick={() => {}}>
            Label
          </Buttons.DestructiveSmall>
          <div>-</div>
          <Buttons.DestructiveSmall icon={icon} isDisabled={true} onClick={() => {}}>
            Label
          </Buttons.DestructiveSmall>
          <div>-</div>
          <div>-</div>
        </div>

        {/****** TERTIARY NORNAL ******/}
        <div style={columnStyle6}>
          <Buttons.TertiaryNormal onClick={() => {}}>Label</Buttons.TertiaryNormal>
          <Buttons.TertiaryNormal icon={icon} onClick={() => {}}>
            Label
          </Buttons.TertiaryNormal>
          <Buttons.TertiaryNormal icon={icon} isPressed={true} onClick={() => {}}>
            Label
          </Buttons.TertiaryNormal>
          <Buttons.TertiaryNormal icon={icon} isDisabled={true} onClick={() => {}}>
            Label
          </Buttons.TertiaryNormal>
          <Buttons.TertiaryNormal icon={icon} isMuted={true} onClick={() => {}}>
            Label
          </Buttons.TertiaryNormal>
          <Buttons.TertiaryNormal icon={icon} isDestructive={true} onClick={() => {}}>
            Label
          </Buttons.TertiaryNormal>
        </div>

        {/****** TERTIARY SMALL ******/}
        <div style={columnStyle6}>
          <Buttons.TertiarySmall onClick={() => {}}>Label</Buttons.TertiarySmall>
          <Buttons.TertiarySmall icon={icon} onClick={() => {}}>
            Label
          </Buttons.TertiarySmall>
          <Buttons.TertiarySmall icon={icon} isPressed={true} onClick={() => {}}>
            Label
          </Buttons.TertiarySmall>
          <Buttons.TertiarySmall icon={icon} isDisabled={true} onClick={() => {}}>
            Label
          </Buttons.TertiarySmall>
          <Buttons.TertiarySmall icon={icon} isMuted={true} onClick={() => {}}>
            Label
          </Buttons.TertiarySmall>
          <Buttons.TertiarySmall icon={icon} isDestructive={true} onClick={() => {}}>
            Label
          </Buttons.TertiarySmall>
        </div>
      </div>

      {/************ THIRD ROW ************/}
      <div style={{ ...rowStyle, margin: '32px 0' }}>
        <div></div>
        <div>quaternary</div>
        <div></div>
        <div></div>
      </div>
      <div style={rowStyle}>
        <div style={columnStyle6}>
          <div>
            default
            <br />
            (no icon)
          </div>
          <div>default</div>
          <div>pressed</div>
          <div>disabled</div>
          <div>muted</div>
          <div>destructive</div>
        </div>

        {/****** QUARTERNARY ******/}
        <div style={columnStyle6}>
          <Buttons.QuaternaryNormal onClick={() => {}}>Label</Buttons.QuaternaryNormal>
          <Buttons.QuaternaryNormal icon={icon} onClick={() => {}}>
            Label
          </Buttons.QuaternaryNormal>
          <Buttons.QuaternaryNormal icon={icon} isPressed={true} onClick={() => {}}>
            Label
          </Buttons.QuaternaryNormal>
          <Buttons.QuaternaryNormal icon={icon} isDisabled={true} onClick={() => {}}>
            Label
          </Buttons.QuaternaryNormal>
          <Buttons.QuaternaryNormal icon={icon} isMuted={true} onClick={() => {}}>
            Label
          </Buttons.QuaternaryNormal>
          <div>–</div>
        </div>
      </div>
    </div>
  );
};

export default ButtonsPage;
